module.exports = __webpack_public_path__ + "static/media/celebrity-logo.c24ab33f.png";